import { checkIsIn3D } from '@/utils';
function calculateCardsInWindow(cardWidth: number, cardHeight: number): number {
  // 获取窗口的宽度和高度
  const windowWidth = window.innerWidth - 144;
  const windowHeight = window.innerHeight;

  // 计算可以放置的卡片行数和列数
  const columns = Math.floor(windowWidth / cardWidth);
  const rows = Math.floor(windowHeight / cardHeight);

  // 计算总卡片数
  const totalCards = rows * columns;
  if (totalCards > 90) {
    return 90
  } else if (totalCards > 60) {
    return 60
  } else {
    return 34
  }
}
export const size = checkIsIn3D() ? calculateCardsInWindow(96, 96) : calculateCardsInWindow(240, 280)
export const downPreloadingHeight = 810
// 顶部400
export const topPreloadingHeight = 400
// 小屏幕下的设置
export const smallSetting = {
  width: 180,
  margin: 6,
  boxMargin: 16
}
// 大屏幕下的设置
export const largeSetting = {
  width: 240,
  margin: 12,
  boxMargin: 24
}
// 断点
export const breakpoint = 800;

/* 
* @description 根据total和records计算当前总数
*/
export const getTotal = (current: number, total: number, records?: any[]) => {
  let currentTotal = total
  if (total === 0 && records?.length === size) {
    currentTotal = 100000
  }

  if (total === 0 && (records && records?.length < size)) {
    currentTotal = size * (current - 1) + records?.length
  }
  if (total === 0 && current !== 1 && (!records || records?.length === 0)) {
    currentTotal = size * (current - 1)
  }
  return currentTotal
}
/* 
* @description 根据total和records计算当前总数(首屏)
*/
export const getMaterialTotal = (current: number, total: number, records?: any[]) => {
  let currentTotal = total
  if (total === 0 && records?.length === size) {
    currentTotal = 100000
  }

  if (total === 0 && (records && records?.length < size)) {
    currentTotal = 100000
  }
  if (total === 0 && current !== 1 && (!records || records?.length === 0)) {
    currentTotal = size * (current - 1)
  }
  return currentTotal
}
